import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import hamburgerIcon from '../../../../images/icons/hamburger-new.png';
import SearchBar from './search-bar';
import OrgSelect from './org-select';
import TermsConditions from './terms-conditions';
import AccountDropdown from './account-dropdown';

import './nav-header.scss';

import narrativLogo from '../../../../images/logos/narrativ_icon_4.png';

class NavHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNotice: false, // Feature toggle for notice banner
      editSearchTerm: '',
      previousSearch: null,
    };

    this.staticRoutes = this.props.staticRoutes;
  }

  componentDidMount() {
    window.addEventListener('mousedown', this.handleClick.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleClick.bind(this));
  }

  handleClick(event) {
    if (this.dropdownNode && !this.dropdownNode.contains(event.target)) {
      this.dropdownNode.classList.remove('open');
    }
  }

  dismissNotice() {
    this.setState({ showNotice: false });
  }

  render() {
    if (!this.props.currentUser) return null;

    return (
      <div className={`nav-header ${this.props.isMobile ? 'mobile' : ''} fs-unmask`}>
        <div className="nav-hamburger" onClick={this.props.toggleNavSidebar}>
          <img src={hamburgerIcon} alt="Menu" />
        </div>
        <Link className="nav-logo" to="/v2">
          {/* Logo when the nav is collapsed */}
          <img src={narrativLogo} alt="Narrativ" />
        </Link>

        <SearchBar navSidebarCollapsed={this.props.navSidebarCollapsed}></SearchBar>

        <AccountDropdown
          className="nav-item"
          currentUser={this.props.currentUser}
          userRole={this.props.userRole}
        ></AccountDropdown>

        <OrgSelect
          className="nav-item"
          currentUser={this.props.currentUser}
          update={this.props.update}
          isMobile={this.props.isMobile}
        ></OrgSelect>

        {/* This is only shown when we want to notify publishers of changes to our T&C */}
        <TermsConditions
          showNotice={this.state.showNotice}
          userRole={this.props.userRole}
          clickHandler={this.dismissNotice.bind(this)}
        ></TermsConditions>
      </div>
    );
  }
}

export default withRouter(NavHeader);
